import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from 'app/shared/services/MyServices/common.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dynamicfilter',
  templateUrl: './dynamicfilter.component.html',
  styleUrls: ['./dynamicfilter.component.scss']
})
export class DynamicfilterComponent implements OnInit,OnChanges {

@Input() filtersConfig: string[] = [];
@Output() filtersApplied = new EventEmitter<any>();
@Input() isReset: boolean;
  form: FormGroup;
  showFilters = false;
  districtArray: any;
  stateArray: any;
  sub = new Subscription
  constructor(private fb: FormBuilder,private commonservices: CommonService) {}
  ngOnChanges(changes: SimpleChanges): void {
   if (changes['isReset'] && changes['isReset'].currentValue) {
    if (this.isReset) {
      this.form.reset();
    }
   }
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [''],
      category: [''],
      date: [''],
      location:[''],
      mobile: [''],
      fromDate: [''],
      toDate: [{ value: '', disabled: true }],
      registration_number: [''],
      vc_number:[]
    });
   this.form.get('fromDate').valueChanges.subscribe(fromDate => {
  const toDateControl = this.form.get('toDate');

  if (fromDate) {
    toDateControl.enable();

    const currentToDate = toDateControl.value;

    if (currentToDate) {
      // If To Date is less than From Date, reset it
      if (new Date(currentToDate) < new Date(fromDate)) {
        toDateControl.setValue('');
      }
    } else {
      // If no To Date selected, set today's date
      const today = new Date();
      const formattedToday = today.toISOString().split('T')[0]; // Format as yyyy-MM-dd
      toDateControl.setValue(formattedToday);
    }

  } else {
    toDateControl.disable();
    toDateControl.setValue('');
  }
});

  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  applyFilter() {
    this.showFilters = false;
    console.log('Applied Filters:', this.form.value);
     this.filtersApplied.emit(this.form.value);
  }
   onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  resetFilters() {
    this.filtersApplied.emit("reset");
    this.form.reset();
    this.showFilters = false;
  }

  isVisible(field: string): boolean {
    return this.filtersConfig.includes(field);
  }
   onstate() {
      this.sub.add(this.commonservices.getLocations().subscribe(
        data => {
          this.stateArray = data;
        }, (err) => {
          Swal.fire(err.error.data.msg)
        }))
  
    }
    ondistrict(value) {
      value = this.stateArray.filter((item: any) => item.name == this.form.controls['state'].value)
      value = value[0];
  
      let json = { "state": { "code": value.code, "state": value.state } }
  
      this.commonservices.getDistrctList(json).subscribe(
        data => {
          this.districtArray = data;
        }, (err) => {
          Swal.fire('Oops...', err.error.data.msg, 'error')
        }
      );
    }
    toUppercase(controlName: string) {
  const currentValue = this.form.get(controlName).value || '';
  this.form.get(controlName).setValue(currentValue.toUpperCase(), { emitEvent: false });
}
getToday(): string {
  return new Date().toISOString().split('T')[0]; // yyyy-MM-dd
}

}